import { create } from 'zustand'

const useSelectStore = create((set) => ({
  listSubject: {},
  setListSubject: (listSubject) => set(() => ({ listSubject }))
}))

export default useSelectStore